import { StandardInput } from '../../../components/forms';
import { ComponentType, ReactNode } from 'react';
import { TaskContentEntity } from '../../../types/game-document/';
import { EditorMode } from '../../../types/editor-mode';
import { ComboboxInput } from '../../../components/form-input';
import { TaskContentFullEditor } from './task-content-full-editor';
import RequiredFields from '../../../types/required-fields';
import { Checkbox } from '@progress/kendo-react-inputs';

interface TaskContentEditorProps {
  editorMode: EditorMode;
  entity: TaskContentEntity;
  handleEntityChange?: (entityKey: string, value: string) => void;
  children?: ReactNode | undefined;
  requiredFields?: RequiredFields<TaskContentEntity>[];
  isNew?: boolean;
  createTask?: boolean;
  onCreateTaskChange?: (checked: boolean) => void;
  title?: string;
  onTitleChange?: (value: string) => void;
}

export const TaskContentEditor: ComponentType<TaskContentEditorProps> = ({
  editorMode,
  entity,
  handleEntityChange = () => {},
  requiredFields,
  isNew,
  createTask,
  onCreateTaskChange,
  title,
  onTitleChange,
  ...props
}: TaskContentEditorProps) => {
  return (
    <>
      {editorMode === 'basic' && (
        <>
          <StandardInput
            name={'title'}
            label={'Title'}
            value={title ?? ''}
            validationMessage={
              requiredFields?.find((item) => item.name === 'title')
                ?.errorMessage
            }
            onChange={(e) => onTitleChange?.(e.target.value as string)}
          />
          <StandardInput
            name={'description'}
            label={'Description'}
            value={entity?.description}
            onChange={(e) =>
              handleEntityChange('description', e.target.value as string)
            }
          />
          <ComboboxInput
            label={'Body type'}
            value={entity?.bodyType}
            name={'bodyType'}
            clearButton={false}
            onChange={(e) =>
              handleEntityChange('bodyType', e.target.value as string)
            }
            data={['HTML', 'Markdown']}
          />
          {isNew && (
            <Checkbox
              label={'Create Task from this Task Content'}
              checked={createTask ?? true}
              onChange={(e) => onCreateTaskChange?.(e.value)}
            />
          )}
        </>
      )}

      {editorMode === 'full' && (
        <TaskContentFullEditor
          entity={entity}
          handleEntityChange={handleEntityChange}
          requiredFields={requiredFields}
        />
      )}
      {props.children}
    </>
  );
};
